import React, { Component } from 'react'
import Checkbox from '../Checkbox/Checkbox';
import './styles.sass';
import RadioButton from '../RadioButton/RadioButton';

export default class SelectItemList extends Component {



    // componentDidMount() {
        
    //     this.initList()
    // }

    // initList = () => {
    //     let array = []
    //     const { itemsList,masterChecked } = this.props

    //     itemsList.items.map((item) => {
    //         if(item.isChecked || masterChecked) array.push(item.id)
    //     })

    //     this.setState({
    //         checkedList: array,
    //         masterChecked: itemsList.isChecked ? true : null
    //     })
        
    //     //console.log('INIT checkList masterChecked', masterChecked);
    // }

    callback = (id, isChecked, label) => {
        const { type, itemsList, checkedList } = this.props
         if(!isChecked) {
            // false al master 

            var filtered = checkedList.filter(function(value, index, arr){
                return value !== id;
            });
            if (type==="radio")
                filtered = []    
            
            this.props.callback(filtered, this.props.index)
            //console.log('CALLBACK REMOVE filtered ', filtered);
        } else {
            
            if (type==="checkbox"){
                checkedList.push(id)
                this.props.callback(checkedList, this.props.index)
            }else{
                let checkedListReset = []
                checkedListReset[0]=id
                this.props.callback(checkedListReset, this.props.index)
                if (this.props.callbackHour)
                    this.props.callbackHour(label,this.props.orario)
            }
            
            
                
            //console.log('CALLBACK ADD checkList ', checkedList)
        }
        
    }

    masterCallback = (index, isChecked) => {
        const { itemsList } = this.props
        let checkedList = []
        
        if(!isChecked) {

            checkedList = []
            
        }
        else{
            itemsList.items.map((item, index) => {
                checkedList.push(item.id);
            })
        }
        this.props.handleMasterSelection(checkedList, this.props.index, isChecked, this.props.multiSelectIndex)
        // this.props.callback(checkedList, this.props.index)
    }
    


    buildContent = (type, items) => {
        const { masterChecked, checkedList} = this.props
        //console.log('masterChecked',masterChecked);
        
        //console.log('BUILD checkList ', checkedList);
        //console.log('items.multiSelect',items.multiSelect)
        return(
            <>
                <div className="select-all">
                    <span>{items.category}</span>
                    {
                        
                        
                        type==="checkbox" && items.items.length > 1 &&
                            <Checkbox isChecked={masterChecked} callback={this.masterCallback} label="Tutto" labelAll="true"/>    
                    }
                </div>
                {
                    items.items.map((item, index) => {
                        //console.log('item',item);
                        if ( checkedList !== undefined ) {
                            return (
                                type==="checkbox" ?
                                    <Checkbox key={index} id={item.id} isChecked={ (masterChecked !== null ? masterChecked : checkedList.indexOf(item.id) !== -1) } index={index} callback={this.callback} label={item.label}/>
                                :
                                    this.props.orario ?
                                        <RadioButton key={index} id={item.id} isChecked={ item.label == this.props.timeTxt} index={index} callback={this.callback} label={item.label}/>
                                    : 
                                        <RadioButton key={index} id={item.id} isChecked={ (masterChecked !== null ? masterChecked : checkedList.indexOf(item.id) !== -1) } index={index} callback={this.callback} label={item.label}/>
                            )
                        }
                    })
                }
                <div className="end-line"></div>
            </>
        )
    }

  render() {
    const { type, itemsList } = this.props
    const content = this.buildContent(type, itemsList)
    //console.log('type',type);
    
    // if(this.props.callback) this.props.callback(checkedList)
    return (
      <div className="select-item-group">
        {
            content
        }
      </div>
    )
    
  }
}